import root from 'window-or-global';
import * as ProductActions from '../../actions/ProductActions';
import deepmerge from 'deepmerge';
import format from 'date-fns/format';
import parse from 'date-fns/parse';

const getMonthYearFromDate = dateString =>
  format(parse(dateString), 'MMMM YYYY');

import {
  getFullName,
} from 'config/utils';

// exported for waggle
export function getInitialState () {
  const initialState = root.INITIAL_STATE;
  if (!initialState || (initialState && !Object.keys(initialState).length)) {
    return {};
  }

  const { offer: o } = initialState;

  return {
    avatar: o.avatar,
    seller: o.seller,
    isCartEnabled: initialState.is_cart_enabled,
    isStoreEnabled: initialState.is_store_enabled,
    productsInStore: initialState.products_in_store,
    isUserOwner: initialState.is_owner,
    joinedDate: null,
  };
}

const sellerInfo = (state = getInitialState(), action) => {
  switch (action.type) {
    case ProductActions.PROFILE_REQUEST_SUCCESS: {
      return deepmerge(state, {
        joinedDate: getMonthYearFromDate(action.response.memberSince),
      });
    }

    default:
      return state;
  }
};

export default sellerInfo;

export const getSellerAvatar = state => state.avatar;

export const getSellerUsername = state => state.seller.username;

export const getIsStoreEnabled = state => state.isStoreEnabled;

export const getIsCartEnabled = state => state.isCartEnabled;

export const getProductsInStore = state => state.productsInStore;

export const getIsUserOwner = state => state.isUserOwner;

export const getSellerFullName = state => getFullName(state.seller);

export const getJoinedDate = state => state.joinedDate;



// WEBPACK FOOTER //
// ./src/product/reducers/product/sellerInfo.js